import React from "react";

import { ScimLogModelFrontend } from "@performyard/service-contracts";

import Chip from "../../../../../components/Chip";
import Link from "../../../../../components/Link";
import { ScrollableColumn } from "../../../../../components/TableLite/TableLiteScrollable/TableLiteScrollable";
import Text from "../../../../../components/Text";
import TruncatedText from "../../../../../components/Text/TruncatedText";

import { capitalizeWord } from "../../../../../utils/stringUtils";
import { filterScimLog, getEventTimeCell, getStatusColor } from "../utils";

export const getScimLogTableColumns = (setModalContent: (log: ScimLogModelFrontend) => void) => {
	const columns: ScrollableColumn[] = [
		{
			id: "eventTime",
			width: 182,
			label: "Event Time",
			isSortable: false,
			getter: getEventTimeCell,
		},
		{
			id: "type",
			width: 190,
			label: "Type",
			isSortable: false,
			getter: (scimLog: ScimLogModelFrontend) => (
				<Text size="paragraph-3" weight="regular">
					{capitalizeWord(scimLog.scimLogType)}
				</Text>
			),
		},
		{
			id: "status",
			width: 190,
			label: "Status",
			isSortable: false,
			getter: (scimLog: ScimLogModelFrontend) => (
				<Chip label={capitalizeWord(scimLog.status)} color={getStatusColor(scimLog.status)} />
			),
		},
		{
			id: "details",
			width: 190,
			label: "Details",
			isSortable: false,
			getter: (scimLog: ScimLogModelFrontend) => {
				// Filter out details we don't want to show from log
				// For deactivate logs, deactivation status and termination date are
				// filtered out and view details modal isn't shown unless additional details are available
				const filteredScimLog = filterScimLog(scimLog);

				// Determine if filtered log has details we want to show in modal and only show link if it does
				const hasUpdates = filteredScimLog.status === "completed" && filteredScimLog.updates?.length;
				const hasError = filteredScimLog.status === "failed" && filteredScimLog.errorMessage;

				if (hasUpdates || hasError) {
					return (
						<div
							onClick={(e) => {
								e.preventDefault();
								setModalContent(filteredScimLog);
							}}
						>
							<Link href="">View Details</Link>
						</div>
					);
				}
			},
		},
		{
			id: "userInfo",
			width: 284,
			label: "User Info",
			isSortable: false,
			getter: (scimLog: ScimLogModelFrontend) => (
				<TruncatedText
					text={scimLog.affectedUser?.email}
					size="paragraph-3"
					weight="regular"
					useTooltip="on-truncate"
					maxWidth={284}
				/>
			),
		},
	];

	return columns;
};
